exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#button-row-wrapper {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  padding: 7px 30px 12px 7px;\n  text-align: right;\n  background: #fff;\n  z-index: 2; }\n  #button-row-wrapper button {\n    margin: 0;\n    margin-right: 10px; }\n    #button-row-wrapper button:last-child {\n      margin-right: 0; }\n  #button-row-wrapper .footer-content {\n    padding-top: 5px;\n    font-size: calc(4px + 1vmin); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/Components/ButtonRow/ButtonRow.scss
// module id = 316
// module chunks = 0